"uses strict";

import Toolbox from "./toolbox";
import ListingClickHandler from "./listing-click-handler";
import { ItemListingState, ItemListingConfig, itemListingConfigModifier } from "./listing-helper";
import ListingFilterHandler from "./listing-filter-handler";
import ListingActionsHandler from "./listing-actions";

const ItemListingListenersHandler = (function () {
	const state = ItemListingState;
	const config = ItemListingConfig;
	const handlers = {};

	const ListenerHandler = {

		init: ( customHandlers) => {

			//workers.cacheHandler = ListingCacheHandler;
			//workers.analyticsHelper = ListingAnalyticsHelper;
			handlers.filterHandler = ListingFilterHandler;
			//workers.listeners = ItemListingListenersHandler;

			handlers.actions = ListingActionsHandler;
			handlers.itemFetcher = {
				fetch: () => {
					return true;
				}
			};

			if (typeof customHandlers === "object" && customHandlers) {
				for (const key of Object.keys(customHandlers)) {
					handlers[key] = customHandlers[key];
				}
			}
		},

		addItemListLazyloader: () => {
			window.addEventListener("scroll", () => {
				Toolbox.throttle(function () {
					if (ItemListingState.lazyLoadCounter < ItemListingState.lazyLoadingTimes) {
						if (!ItemListingConfig.itemListingActions.classList.contains("done") && !ItemListingConfig.itemListingActions.classList.contains("loading")) {
							if ((window.pageYOffset + window.outerHeight + 200) > ItemListingConfig.itemListingActions.offsetTop) {
								handlers.itemsFetcher.fetch();
								ItemListingState.lazyLoadCounter++;
							}
						}
					}
				}, 500, "lazyLoadingThrottle");
			}, Toolbox.listenerOptions());
		},

		addLoadMoreItemsButtonListener: () => {
			const loadMoreProductsButton = document.querySelector(config.loadMoreLink);

			if (loadMoreProductsButton) {
				loadMoreProductsButton.addEventListener("click", (e) => {
					e.preventDefault();
					handlers.itemsFetcher.fetch();
					state.lazyLoadCounter = 0;
				});
			}
		},

		listenFilterChanges: () => {
			// We are listening listing-filters data-attribute changes in order to detect when reload products when filter changes.
			const filterChangeObserver = new MutationObserver(function (e) {

				for (const mutator of e) {

					const element = mutator.target;

					switch (mutator.attributeName) {
						case "data-listing-filters":
						case "data-product-list-filters":
							if (state.skipFetch === false) {
								if (mutator.oldValue !== element.getAttribute(config.filterDataSelector)) {

									handlers.actions.setNextPage();

									handlers.itemsFetcher.fetch(true);

								}
							} else {
								state.skipFetch = false;
							}
							break;
						case "data-value":

							Toolbox.waitForFinalEvent(() => {
								handlers.filterHandler.updateFilterState();
							}, 1000, "filterValueChange");

							break;

					}

				}
			});

			filterChangeObserver.observe(document.querySelector(config.filterBarSelector), {
				childList: false,
				attributes: true,
				subtree: true,
				attributeOldValue: true
			});

			const updateSelected = (element) => {
				if (element.dataset.selected) {
					const selectedOptions = JSON.parse(element.dataset.selected).map(
						item => {
							if (item.name !== undefined) {
								return item.name;
							} else {
								return item;
							}
						}
					);
					const so = element.querySelector(".label-additions, .selected-options");
					so.innerHTML = ": " + Toolbox.escapeFractionsString(selectedOptions.join(", "));
				} else {
					element.querySelector(".label-additions, .selected-options").textContent = "";
				}
			};

			const accordionChangeObserver = new MutationObserver(function (e) {
				for (const mutator of e) {
					const element = mutator.target;
					switch (mutator.attributeName) {
						case "data-selected":

							updateSelected(element);
							break;
					}

				}

			});

			for (const accordion of document.querySelectorAll(config.mobileFilterBarSelector + " .component[data-type=accordion]")) {
				updateSelected(accordion);
			}

			accordionChangeObserver.observe(document.querySelector(config.mobileFilterBarSelector), {
				childList: false,
				attributes: true,
				subtree: true,
				attributeOldValue: true
			});

		},

		addFilterListeners: (listenerAreaSelector, isMobile) => {

			if (!isMobile) {

				window.addEventListener("resize", () => {
					Toolbox.throttle(() => {
						handlers.actions.adjustFilters(true);
					}, 1000, "adjustFilters");
					Toolbox.waitForFinalEvent(() => {
						const filterBarDropdown = document.querySelector(".bar-dropdown-view.dropdown-visible");
						if (filterBarDropdown) {
							handlers.actions.calculateBarDropdownHeight(filterBarDropdown);
						}

					}, 200, "filterResizeHelper");
				});

			}

			const filterItems = document.querySelector(listenerAreaSelector);
			const clickHandler = new ListingClickHandler();
			if (isMobile) {
				clickHandler.settings.isMobile = true;
			}
			filterItems.addEventListener("click", (e) => { clickHandler.processClick(e); });
			filterItems.addEventListener("keyup", (e) => {
				if (e.key === " " || e.key === "Enter") {
					clickHandler.processClick(e);
				}
			});

		},

		addAccessibilityHelperListeners: () => {
			window.addEventListener("keyup", ListenerHandler.accessibilityHelper);
		},

		blockEvents: (e) => {
			e.preventDefault();
			e.stopPropagation();
			//e.stopImmediatePropagation();
		},

		addBlurListener: (callback) => {
			document.body.addEventListener("click", callback, true);
			document.body.addEventListener("keyup", callback, true);
			document.body.addEventListener("mouseover", ListenerHandler.blockEvents, true);
			document.body.addEventListener("mouseout", ListenerHandler.blockEvents, true);
		},

		removeBlurListener: (callback) => {
			document.body.removeEventListener("click", callback, true);
			document.body.removeEventListener("keyup", callback, true);
			document.body.removeEventListener("mouseover", ListenerHandler.blockEvents, true);
			document.body.removeEventListener("mouseout", ListenerHandler.blockEvents, true);
		},

		accessibilityHelper: (e) => {
			if (e.key === "Tab") {

				const components = document.querySelectorAll(".components");

				for (const element of components) {
					element.classList.add("show-focus-outline");
				}

				window.removeEventListener("keyup", ListenerHandler.accessibilityHelper);
			}

		},

		dropdownBlur: (e) => {

			const closeMenus = () => {
				ListenerHandler.removeBlurListener(ListenerHandler.dropdownBlur);
				const openMenus = document.querySelectorAll(".component.dropdown-down");
				for (const om of openMenus) {
					om.classList.remove("dropdown-down");
				}
				document.querySelector(".bar-dropdown-view").classList.remove("dropdown-visible");
				handlers.actions.cleanHiddenViews();
			};

			if (e.type === "keyup") {
				if (e.key === "Escape") {
					closeMenus();
					return;
				}
			}

			let menu = Toolbox.closest(e.target, ".component-dropdown, .bar-dropdown-view, .component .component-lite");

			if (menu) {
				if (menu.dataset.id === "filterMenuToggle") {
					menu = null;
				}

			} else {
				e.preventDefault();
				e.stopPropagation();
				//e.stopImmediatePropagation();
			}

			if (menu === null) {

				if (e.type === "keyup") {
					if (e.key === " " || e.key === "Enter") {
						closeMenus();
					}
				} else if (e.type === "click") {
					closeMenus();
				}

			}

		},

		filterMenuBlur: (e) => {

			const menu = Toolbox.closest(e.target, config.mobileFilterBarSelector);

			const menuToggle = (preventDefault) => {
				if (preventDefault) {
					e.preventDefault();
					e.stopPropagation();
					//e.stopImmediatePropagation();
				}
				ListenerHandler.removeBlurListener(ListenerHandler.filterMenuBlur);
				handlers.actions.filterMenuToggle();
			};

			if (e.type === "keyup") {
				if (e.key === "Escape") {
					menuToggle();
					return;
				}
			}

			if (menu === null) {

				if (e.type === "keyup") {
					if (e.key === " " || e.key === "Enter") {
						menuToggle(true);
					}
				} else if (e.type === "click") {
					menuToggle(true);
				}

			}

		},

		addListeners: (customListeners) => {
			ListenerHandler.addAccessibilityHelperListeners();
			ListenerHandler.listenFilterChanges();
			ListenerHandler.addFilterListeners(config.filterBarSelector, false);
			ListenerHandler.addFilterListeners(config.mobileFilterBarSelector, true);
			ListenerHandler.addItemListLazyloader();
			ListenerHandler.addLoadMoreItemsButtonListener();

			if (Array.isArray(customListeners)) {
				for (const customListener of customListeners) {
					customListener();
				}

			}

		}
		
	};

	return ListenerHandler;


})();

export default ItemListingListenersHandler;
